import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es para todos los niveles de experiencia?',
  a: 'Está diseñado específicamente para corredores recién recibidos o que están buscando armar su primera cartera. Si ya tenés una inmobiliaria armada con empleados, esto te va a quedar chico. Si estás arrancando o tenés 1-2 propiedades, es ideal.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Al instante. Una vez confirmado el pago, te llega un mail con el acceso a la plataforma donde están todos los PDFs, Excels y videos explicativos listos para descargar y usar.'
}, {
  q: '¿Qué lo diferencia del contenido gratis de YouTube/Instagram?',
  a: 'El orden y la aplicación. En redes hay tips sueltos; acá hay un sistema paso a paso, con plantillas editables que copiás y pegás. No perdés tiempo uniendo piezas.'
}, {
  q: '¿La garantía es real?',
  a: '100% real. Procesamos los pagos a través de Mercado Pago/Hotmart, lo que significa que tu dinero está protegido. Si pedís reembolso dentro de los 7 días, se hace automático.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-lighter px-6 lg:px-8" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <div className="text-center mb-12" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4" data-id="element-72">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-73">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-brand-light overflow-hidden shadow-sm" data-id="element-74">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between font-bold text-brand-navy hover:bg-brand-lighter/50 transition-colors" data-id="element-75">
                {faq.q}
                <ChevronDown className={`w-5 h-5 text-brand-accent transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="px-6 pb-5 text-brand-navy/70" data-id="element-78">
                    {faq.a}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}